const localDevelopment = ['localhost', '127.0.0.1'].includes(location.hostname);
const devtoolsPreference = localStorage.getItem('xca-app-core_devtools');
let devtools = false;
if (localDevelopment && devtoolsPreference !== 'false') {
  devtools = true;
} else if (devtoolsPreference === 'true') {
  devtools = true;
}


export let settings = {
  devtools
};
export default settings;


export const setSettings = (_settings) => {
  settings = {...settings, ..._settings};
};
